import { CustomCheckboxInput, QuestionCard } from '@my/ui'
import { Control, useWatch } from 'react-hook-form'

import { InputField } from '../helpers/Helper'
import images from '../../../assets/images'
import { confirmationOptions } from '../data'

interface FamilyAndCulturalConsiderationsProps {
  control: Control<any>
}

export const FamilyAndCulturalConsiderations: React.FC<FamilyAndCulturalConsiderationsProps> = ({
  control,
}) => {
  const hasImpacts = useWatch({name: "Family and Cultural Considerations - Has Impacts"});
  const hasChanges = useWatch({name: "Family and Cultural Considerations - Has Life Changes Anticipated"});
  return (
    <>
      <QuestionCard
        questionGroupTitle="Are there any family responsibilities or cultural practices that impact your financial planning (e.g., supporting elderly parents, planning for children)?"
      >
        <CustomCheckboxInput
          options={confirmationOptions}
          control={control}
          name="Family and Cultural Considerations - Has Impacts"
        />

        {hasImpacts && <>
          <InputField
            control={control}
            name="Family and Cultural Considerations - Impacts"
            placeholder="Description"
            height={90}
            multiline
          />
        
          <InputField
            control={control}
            name='Expenses - Monthly - Family/Cultural Support'
            placeholder="Approximate monthly amount"
            icon={images.money}
          />
        </> }
      </QuestionCard>
      <QuestionCard
        questionGroupTitle="Are you planning any major life changes that could impact your financial situation (e.g., marriage, starting a family, moving abroad)?"
      >
        <CustomCheckboxInput
          options={confirmationOptions}
          control={control}
          name="Family and Cultural Considerations - Has Life Changes Anticipated"
        />

        {hasChanges && <InputField
          control={control}
          name="Family and Cultural Considerations - Life Changes Anticipated"
          placeholder="Description"
          height={90}
          multiline
        />}
      </QuestionCard>
    </>
  )
}
